'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getClass(classNames) {
  var className = classNames;
  if ((typeof classNames === 'undefined' ? 'undefined' : (0, _typeof3.default)(classNames)) === 'object') {
    var width = global.window.innerWidth;
    (0, _lodash.orderBy)((0, _keys2.default)(classNames), null, 'desc').find(function (key) {
      if (key < width) {
        className = classNames[key];
        return true;
      }

      return false;
    });
  }

  return className;
}

exports.default = getClass;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/ApplyClass/getClass.js
// module id = 569
// module chunks = 0